import { MOVE_ROW_BENEFICIARY_STATUS } from '@/modules/move/entities/enums/move';
import ICONS from '@/shared/entities/constants/icons';
import { random } from 'lodash';
import React from 'react';
import { Button, Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

interface BeneficiaryStatusNumbersProps {
  loading: boolean;
  statuses: Record<MOVE_ROW_BENEFICIARY_STATUS, number>;
  loadData?: () => Promise<void>;
}

export const BeneficiaryStatusNumbers: React.FC<BeneficiaryStatusNumbersProps> = ({
  loading,
  statuses,
  loadData,
}) => {
  const countInitialStatus =
    statuses[MOVE_ROW_BENEFICIARY_STATUS.VALIDATED] +
    statuses[MOVE_ROW_BENEFICIARY_STATUS.NOT_INITIALIZED];
  const countErrors = statuses[MOVE_ROW_BENEFICIARY_STATUS.VALIDATED_WITH_ERROR];
  const countReviews = statuses[MOVE_ROW_BENEFICIARY_STATUS.PROCESSED_WITH_ERROR];
  const countProcessed = statuses[MOVE_ROW_BENEFICIARY_STATUS.PROCESSED];

  return (
    <Grid gap={24} alignItems='center'>
      {!loading ? (
        <>
          <Text
            icon={ICONS.ALERT}
            iconColor='danger'
            value={`${countErrors} ${countErrors === 1 ? 'Erro' : 'Erros'}`}
            title
            size='minor'
          />
          <Text
            icon={ICONS.WARNING}
            iconColor='warning'
            value={`${countReviews} ${countReviews === 1 ? 'Crítica' : 'Críticas'}`}
            title
            size='minor'
          />
          <Text
            icon={ICONS.CLOCK}
            iconColor='light'
            value={`${countInitialStatus} Em andamento`}
            title
            size='minor'
          />
          <Text
            icon={ICONS.CHECK_CIRCLE}
            iconColor='success'
            value={`${countProcessed} ${countProcessed === 1 ? 'Concluído' : 'Concluídos'}`}
            title
            size='minor'
          />
        </>
      ) : (
        Array.from({ length: 4 }).map(() => (
          <div style={{ width: 100 }} key={random(0, 999)}>
            <Text value='' rounded />
          </div>
        ))
      )}

      {loadData && (
        <Button
          size='small'
          rounded
          label='Atualizar'
          icon={ICONS.SYNC}
          loading={loading}
          onClick={loadData}
        />
      )}
    </Grid>
  );
};
